console.log('From view component!!!');